<template>
	<div class="page pageContainer">
		<div class="nav">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>基础数据</el-breadcrumb-item>
				<el-breadcrumb-item>缴费项目</el-breadcrumb-item>

			</el-breadcrumb>
			<div style="position: absolute; top: 0; right: 0;">
				<el-button type="primary" size="small" @click="addNew">添加缴费项</el-button>
			</div>

		</div>


		<el-form ref="form" :model="FormData" label-width="80px">
			<div style="color: orange; font-size: 12px; padding-bottom: 10px; padding-left: 200px;"> 提示：分组相同在填费用时只需选择一个即可</div>
			<el-row :gutter="20" v-for="(item,idx) in DataList" :key="idx">
				<el-col :span="10">
					<el-form-item label="缴费名称">
						<el-input v-model="item.fee_name" placeholder="请输入缴费名称"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="4">
					<el-form-item label="缴费金额">
						<el-input v-model="item.fee_price" placeholder="请输入缴费金额"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="4">
					<el-form-item label="分组">
						<el-input v-model="item.fee_code" placeholder="分组"></el-input>
					</el-form-item>
				</el-col>
				<!-- <el-col :span="5">
					<el-form-item label="关联代码">
						<el-input v-model="item.fee_code" placeholder="请输入关联代码"></el-input>
					</el-form-item>
				</el-col> -->
				<el-col :span="6">
					<el-form-item>
						<el-button type="primary" size="small" icon="el-icon-s-claim" @click="updateItem(item)">保存</el-button>
						<el-button type="danger" size="small" icon="el-icon-delete" @click="deleteItem(item)">删除</el-button>
					</el-form-item>
				</el-col>
			</el-row>




			<el-form-item>

			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				FormData: {
					id: 0,
					fee_code: "",
					fee_value: "",
					fee_name: "",
					fee_price: "",
					remark: ""
				},
				DataList: []
			}
		},
		mounted() {
			this.getList()

		},
		methods: {
			getList() {
				this.$http.post("/api/t_sch_cost_list", {
					pagesize: 200
				}).then(res => {
					this.DataList = res.data.data
					if (this.DataList.length == 0) {
						this.DataList = [{
							id: 0,
							fee_code: "",
							fee_value: "",
							fee_name: "",
							fee_price: "",
							remark: ""
						}]
					}
				})
			},
			updateItem(item) {

				this.$http.post("/api/t_sch_cost_edit", item).then(res => {
					this.getList()
					this.$message({
						type: 'success',
						message: '保存成功'
					});
				})
			},
			deleteItem(item) {

				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("/api/t_sch_cost_delete", {
						id: item.id
					}).then(res => {
						this.$message({
							type: 'success',
							message: '删除成功'
						});

						this.getList();
					})

				}).catch(() => {

				});
			},
			addNew() {
				this.DataList.push({
					id: 0,
					fee_code: "",
					fee_value: "",
					fee_name: "",
					fee_price: "",
					remark: ""
				})
			}
		}
	}
</script>

<style>
</style>
